import { render } from "./LayoutsAuthContentsFooter.vue?vue&type=template&id=75a3be74&ts=true"
import script from "./LayoutsAuthContentsFooter.vue?vue&type=script&lang=ts"
export * from "./LayoutsAuthContentsFooter.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__